<script>
  export let value;
</script>

<div class="lt-stat">
  <div class="title">{ value.trait_type }</div>
  {#if typeof value.value === 'string'}
    <div class="value">
      {#if value.args?.format === 'html'}
        {@html value.value }
      {:else}
        { value.value }
      {/if}
    </div>
  {:else}
    {#if value.display_type === 'date'}
      <div class="value">
        <time datetime={ new Date(value.value * 1000).toISOString() }>
          { new Date(value.value * 1000).toLocaleDateString(undefined, { year:"numeric", month:"short", day:"numeric"})  }
        </time>
      </div>
    {:else if value.display_type === 'boost_number'}
      <div class="boost" style="--value:100;">{ value.value }</div>
    {:else if value.display_type === 'boost_percentage'}
      <div class="boost" style="--value:{ value.value };">{ value.value }%</div>
    {:else if value.display_type === 'number'}
      <div class="value">
        {#if value.args?.format === 'html'}
          {@html value.value }
        {:else}
          { value.value }
        {/if}
      </div>
    {:else}
      <progress value={ value.value } max={ value.max_value }></progress>
    {/if}
  {/if}
  {#if value.max_value}
    <div class="desc">{ value.value } of { value.max_value }</div>
  {/if}
</div>